// Vendor Program v3 UAT recon (F9) — qualification-stage query-key factory
// (stale-after-save convention: queryKey arrays live only in *Keys files).

export const vendorQualificationKeys = {
  list: (vendorId: string) =>
    ["portfolio-admin", "vendor-qualifications", vendorId] as const,
};
